import { useMemo } from 'react';
import * as THREE from 'three';

function useGetCamera(): THREE.OrthographicCamera {
  const getCamera = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const viewSize = h;
    const aspectRatio = w / h;

    const viewport = {
      viewSize: viewSize,
      aspectRatio: aspectRatio,
      left: (-aspectRatio * viewSize) / 2,
      right: (aspectRatio * viewSize) / 2,
      top: viewSize / 2,
      bottom: -viewSize / 2,
      near: -10000,
      far: 10000,
    };

    const newCamera = new THREE.OrthographicCamera(
      viewport.left,
      viewport.right,
      viewport.top,
      viewport.bottom,
      viewport.near,
      viewport.far
    );

    return newCamera;
  };

  const camera: THREE.OrthographicCamera = useMemo(() => getCamera(), []);

  return camera;
}

export default useGetCamera;
